import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { AuthTokenService } from './core/auth/auth-token.service';

@Injectable({
    providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
    constructor(private authTokenService: AuthTokenService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.isAuthRefreshRequest(request)) {
            return next.handle(request);
        }

        return from(this.authTokenService.ensureValidAccessToken()).pipe(
            switchMap(() => {
                const token = this.authTokenService.accessToken;
                if (token) {
                    request = request.clone({
                        setHeaders: {
                            Authorization: `${token}`,
                        }
                    });
                }
                return next.handle(request);
            })
        );
    }

    private isAuthRefreshRequest(request: HttpRequest<any>): boolean {
        return request.url.toLowerCase().includes('api/auth/refresh')
            || request.url.toLowerCase().includes('api/auth/login')
            || request.url.toLowerCase().includes('api/auth/loginforsupport');
    }
}
